// src/features/system/jobs/api/jobsApi.ts
import { bff } from '@/lib/http/bff';

export interface JobEvent {
  seq: number;
  /** Epoch milliseconds when the event was produced */
  ts?: number;
  stage?: string;
  percent?: number;
  status?: string;
  message?: string;
  runId?: number | string;
  jobId?: number | string;
  error?: string;
  // Unified stack lifecycle enrichment
  stack_id?: number | string;
  stack_steps?: number;
  stack_completed_steps?: number;
  stack_step_index?: number;
  stack_final?: boolean;
  time_lapsed?: number; // seconds

  /** New pipeline fields (1-based current index) */
  stack_current?: number;

  /** Phase/sub-stage fields (worker-level) */
  phase_name?: string;         // e.g., downloading | splitting | formatting | uploading
  phase_index?: number;        // 0-based
  phase_current?: number;      // 1-based
  phase_total?: number;
  phase_completed?: boolean;

  /** Legacy/compat stage-level fields mirrored by worker */
  stage_index?: number;        // 0-based
  stage_total?: number;
  stage_progress?: number;     // 0..1

  /** Overall progress (0..1); percent will be derived by backend when available */
  overall_progress?: number;   // 0..1

  /** Optional transfer stats for uploading phase */
  uploaded?: number;           // bytes
  total?: number;              // bytes
  stem?: string;
  gcs_uri?: string;

  /** Optional extra timing & worker fields */
  worker_id?: number;
  step_index?: number;         // for step_completed
  duration_ms?: number;        // per-step duration
  total_duration_ms?: number;  // job total duration
}

export interface JobEventsResponse {
  ok: boolean;
  runId: number | string;
  events: JobEvent[];
  lastSeq: number;
  active: boolean;
  done?: boolean; // backend completion flag
}

export interface JobLatestResponse {
  ok: boolean;
  runId: number | string;
  latest: JobEvent;
  lastSeq: number;
  done?: boolean; // backend completion flag
}

export async function fetchJobEvents(runId: string | number, since?: number): Promise<JobEventsResponse> {
  const url = `/jobs/${runId}/events${since != null ? `?since=${since}` : ''}`;
  return bff.get<JobEventsResponse>(url);
}

export async function fetchJobLatest(runId: string | number): Promise<JobLatestResponse> {
  return bff.get<JobLatestResponse>(`/jobs/${runId}/latest`);
}
